<template>
  <div class="h-100">
    <div v-if="isLoaded">
      <div v-if="orders.length">
        <div v-for="(item, index) in orders" :key="index" >
          <div v-if="item.total > 0" class="invoice">
            <div class="invoice__box">
              <div>
                <div class="h5 mb-0 text-muted">{{$t('invoiceRefLabel')}} #{{ item.ref }}</div>
                <div class="text-small">
                  {{ item.title }}
                </div>
              </div>
              <div>
                <div class="link-icon">
                  <span class="icon icon-date"></span>
                  {{ item.orderDate }}
                </div>
              </div>
              <div class="invoice__price">{{ item.total }} €</div>
              <div v-if="getStatus(item.stripeStatus, item.total)">
                <div class="badge badge-pill badge-success">
                  {{ getStatus(item.stripeStatus, item.total) }}
                </div>
              </div>
              <div v-if="getStatus(item.stripeStatus, item.total)" class="invoice__btn">
                <a
                  :href="item.invoiceUrl"
                  class="btn btn-icon btn-primary w-100"
                >
                  <span class="icon icon-file_white"></span>
                    {{$t('buttons.downloadButton')}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="box-block_short box-block text-center">
          <div class="alert alert-primary">
           {{$t('invoiceEmptyList')}}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="h-100">
      <div class="h-100 row d-flex justify-content-center align-items-center">
        <div class="col-12">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Chargement...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'MyInvoices',
  data() {
    return {
      orders: [],
      isLoaded: false,
    }
  },
  computed: {
    ...mapFields(['user']),
  },
  mounted() {
   this.$store.dispatch('getUserOrders').then((data) => {
      this.orders = data
      this.isLoaded = true
      window.scrollTo(0,0)
    })
  },
  methods: {
    getStatus(status, total) {
      if (total > 0) {
        if (status === 'succeeded') {
          return this.$t('paidStatus')
        } else return false
      } else return this.$t('paidStatus')
    },
  },
}
</script>

<style></style>
